<template>
    <div class="home-page" :style="backgroundStyle">
        <div class="background-overlay"></div>
      <HeaderComponent />
      <main>
        <h1>RANDOMCRITD</h1>
        <div class="flavortext">{{ flavortext }}</div>
        <div class="aboutme">Perceval Wieser - {{ age }} years old - Fullstack Dev</div>
        <div class="box-container">
          <div class="box">
            <div class="boxtitle">Projects
                <button @click="toggleBox('projects')" class="toggle-btn">
      {{ boxVisibility.projects ? '−' : '+' }}
    </button>
            </div>
            <div class="boxtext" v-show="boxVisibility.projects">On this website, you'll find most of my public projects.
                <br />
                Yes, I know, bit of a shame I can't show you everything I've done, but hey, you can't have it all, right?
                <br />
                Anyways, here are the things you'll be able to find here :
            </div>
          </div>
          <div class="box">
            <div class="boxtitle">Who am I?
                <button @click="toggleBox('whoami')" class="toggle-btn">
      {{ boxVisibility.whoami ? '−' : '+' }}
    </button>
            </div>
            <div class="boxtext" v-show="boxVisibility.whoami">Well I'm glad you asked!
                <br />
                The name's Perceval Wieser, although I go by many names, including "Parceval", "Brick" or even "RandomCrit".
                <br />
                I'm a {{ age }} years old fullstack developer currently living in France, and as you probably noticed, I love creating "Random" things, hence the name.
                <br />
                Yes I know, I'm french and yet this whole website is in english. Sue me.
                
            </div>
          </div>
          <div class="box">
            <div class="boxtitle">Skills
                <button @click="toggleBox('skills')" class="toggle-btn">
      {{ boxVisibility.skills ? '−' : '+' }}
    </button>
            </div>
            <div class="boxtext" v-show="boxVisibility.skills">Everyone has their own set of skills, and I am no exception to the rule.
            </div>
            <div class="skills-section" v-show="boxVisibility.skills">
                <div class="skills-columns">
                    <!-- Colonne gauche -->
                    <div class="skills-column">
                    <h3>Frameworks</h3>
                    <SkillBar name="JQuery" :level="100" />
                    <SkillBar name="Vue.js" :level="80" />
                    <SkillBar name="Angular" :level="80" />
                    <SkillBar name="Symfony" :level="75" />
                    <SkillBar name="Bootstrap" :level="75" />
                    <SkillBar name="Django" :level="65" />
                    <SkillBar name="Node.js" :level="40" />
                    <SkillBar name="React" :level="20" />
                    <hr />
                    <h3>Databases</h3>
                    <SkillBar name="MySQL" :level="100" />
                    <SkillBar name="MongoDB" :level="70" />
                    </div>

                    <!-- Colonne droite -->
                    <div class="skills-column">
                    <h3>Languages</h3>
                    <SkillBar name="French" :level="100" />
                    <SkillBar name="English" :level="100" />
                    <hr />
                    <h3>Programming languages</h3>
                    <SkillBar name="HTML/CSS/JS" :level="100" />
                    <SkillBar name="Python" :level="100" />
                    <SkillBar name="SQL" :level="100" />
                    <SkillBar name="PHP" :level="100" />
                    <SkillBar name="Java" :level="70" />
                    <SkillBar name="C#" :level="55" />
                    <h3>Softwares</h3>
                    <SkillBar name="Office suite" :level="100" />
                    <SkillBar name="Vmware / VirtualBox" :level="80" />
                    <SkillBar name="Git" :level="100" />
                    <SkillBar name="Gimp / Paint.net" :level="75" />
                </div>
                </div>
                </div>
          </div>
        </div>
      </main>
      <FooterComponent />
    </div>
  </template>
  
  <script>
  import backgroundImage from '@/assets/backgrounds/Background1.png';
  import HeaderComponent from '@/components/Header.vue';
  import FooterComponent from '@/components/Footer.vue';
  import SkillBar from '@/components/SkillBar.vue';
  
  export default {
    name: 'HomePage',
    components: {
      HeaderComponent,
      FooterComponent,
      SkillBar
    },
    data() {
      return {
        flavortextArray: [
          "When life gives you lemons, get MAD.",
          "You don't want to insult the goblins. You really, really don't.",
          "This, is a bucket.",
          "[CENSORED]",
          "I don't know what I'm doing.",
          "You were transported to another location.",
          "For the brain badgers!",
          "No ESC key found. You can't escape.",
          "You do realize.. this means war.",
          "The cake is a lie.",
          "Can't stop, won't stop.",
          "Skaarl is coming.",
          "Apathy's a tragedy and boredom is a crime.",
          "Are none of you worthy?"
        ],
        flavortext: 'loading',
        age: 'loading',
        skills: [
            { name: 'HTML', level: 90 },
            { name: 'CSS', level: 85 },
            { name: 'JavaScript', level: 75 },
            { name: 'Vue.js', level: 70 },
            { name: 'Photoshop', level: 60 }
        ],
        boxVisibility: {
        projects: true,
        whoami: true,
        skills: true
        }
      };
    },
    computed: {
      backgroundStyle() {
        return {
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '100vh',
          width: '100%',
        };
      }
    },
    methods: {
      goToAbout() {
        this.$router.push('/about');
      },
      goToContact() {
        this.$router.push('/contact');
      },
      getRandomFlavortext() {
        const randomText = this.flavortextArray[Math.floor(Math.random() * this.flavortextArray.length)];
        this.flavortext = randomText;  
      },
      getAge() {
        const birthDate = new Date('2004-02-02'); // Remplacez par votre date de naissance
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        this.age = age;
      },
      toggleBox(box) {
        this.boxVisibility[box] = !this.boxVisibility[box];
    },
    
    },
    mounted() {
      this.getRandomFlavortext();
      this.getAge();
      document.title = "Randomcritd";
    }
  };
  </script>
  
  <style scoped>
    @media (min-width: 900px) {
    .toggle-btn {
        display: none;
    }
    }
    .toggle-btn {
    background: none;
    border: none;
    color: #FF9442;
    font-size: 1.5rem;
    cursor: pointer;
    float: right;
    margin-left: 10px;
    }

    .skills-section {
    margin-top: 40px;
    padding: 20px;
    color: white;
    }
    .skills-columns {
    display: flex;
    gap: 40px;
    justify-content: center;
    flex-wrap: wrap;
    }
    .skills-column {
    flex: 1;
    min-width: 250px;
    }
    .skills-column h3 {
    margin-top: 20px;
    margin-bottom: 10px;
    border-bottom: 2px solid #FF9442;
    padding-bottom: 5px;
    }
    hr {
    border: none;
    border-top: 1px solid #888;
    margin: 20px 0;
    }
    .home-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  text-align: center;
  color: white;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
  position: relative;
  z-index: 1;
}

  .background-overlay {
  position: fixed; /* Fixe l'arrière-plan */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(@/assets/backgrounds/Background1.png); /* Votre image de fond */
  background-size: cover; /* Couvre toute la fenêtre */
  background-position: center center;
  background-repeat: no-repeat;
  z-index: -1; /* Place le fond derrière tout le contenu */
}
  
  nav ul {
    list-style-type: none;
    display: flex;
    justify-content: center;
    padding: 0;
    margin: 0;
  }
  
  nav ul li {
    margin: 0 15px;
  }
  
  nav ul li a {
    color: white;
    text-decoration: none;
    font-weight: bold;
  }
  
  main {
  flex: 1; /* This allows main to take up remaining space */
  margin-top: 50px;
}
  
  h1 {
    font-size: 2.5rem;
  }
  
  .flavortext {
    margin-top: 0px;
    font-size: 1rem;
  }
  
  .aboutme {
    margin-top: 20px;
    font-size: 1.5rem;
  }
  
  /* Box container */
  .box-container {
  display: flex;
  flex-wrap: wrap;           /* Allow wrapping */
  justify-content: center;   /* Center items when stacked */
  gap: 20px;                 /* Space between boxes */
  margin-top: 40px;
  padding: 0 20px;
}
  
.box {
  flex: 1 1 300px;           /* Allow to grow/shrink, min width 300px */
  background-color: rgba(19, 19, 19, 0.8);
  color: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  border: double 3px #FF9442;
  box-sizing: border-box;
}
  
  .box:hover {
    background-color: rgba(39, 39, 39, 0.8); /* Changement de couleur au survol */
  }

  .boxtitle {
    font-size: 2rem;
    margin-bottom: 10px;
  }

  .boxtext {
    font-size: 1.2rem;
    margin-top: 10px;
    line-height: 180%;
  }

  @media (max-width: 600px) {
  .box {
    flex: 1 1 100%;
  }
}


  </style>
  